import { useTranslation } from "react-i18next";
import "../styles/PackagesSection.css";

export default function PackagesSection() {
  const { t } = useTranslation("packages");
  const packages = t("packages", { returnObjects: true });

  return (
    <section className="pkg-section">
      <div className="pkg-container">
        <header className="pkg-header">
          <span className="pkg-eyebrow">{t("eyebrow")}</span>
          <h2 className="pkg-title">{t("title")}</h2>
          <p className="pkg-subtitle">{t("subtitle")}</p>
        </header>

        <div className="pkg-grid">
          {packages.map((pkg, i) => (
            <div key={i} className={`pkg-card${pkg.badge ? " pkg-card--featured" : ""}`}>
              {pkg.badge && <div className="pkg-badge">{t("badge")}</div>}
              <div className="pkg-card-top">
                <h3 className="pkg-name">{pkg.name}</h3>
                <p className="pkg-tagline">{pkg.tagline}</p>
              </div>
              <ul className="pkg-features">
                {[...pkg.features].sort((a, b) => b.included - a.included).map((f, j) => (
                  <li key={j} className={`pkg-feature${f.included ? " pkg-feature--yes" : " pkg-feature--no"}`}>
                    <span className="pkg-feature-icon">{f.included ? "✓" : "✕"}</span>
                    {f.label}
                  </li>
                ))}
              </ul>
              <a href="/contactos" className="pkg-cta">
                <span>{pkg.cta}</span>
                <span>→</span>
              </a>
            </div>
          ))}
        </div>

        <p className="pkg-disclaimer">{t("disclaimer")}</p>
      </div>
    </section>
  );
}
